
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-800"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-emerald-300 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-20 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full">
              <i className="ri-smartphone-line text-white text-base"></i>
              <span className="text-sm font-medium text-white whitespace-nowrap">iOS Development Experts</span>
            </div>

            <h1 className="text-7xl font-bold text-white leading-tight">
              Modern Applications<br />
              <span className="text-teal-200">for iOS Platform</span><br />
              That Users Love
            </h1>

            <p className="text-xl text-white/90 leading-relaxed max-w-2xl">
              A team of experts developing cutting-edge applications for the iOS platform. Our products enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full h-[600px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/a26b64162e5308f82ef9deb134db6d87.jpg"
                alt="iOS Applications"
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}